/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  },
  
  instructions: {
    fontSize: 9,
    fontStyle: 'italic',
    color: '#7f8c8d',
    marginBottom: 15,
    padding: 8,
    backgroundColor: '#ecf0f1',
    borderRadius: 3,
  }
});

const ExportDeclarationIncomeForm = ({ user, data, agencyInfo }) => {
  

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <HeaderPDF user={user} data={data} agencyInfo={agencyInfo} />
        
        <Text style={styles.title}>MWOSG Form 01-D - Information Sheet of Employer</Text>
        
        <Text style={styles.instructions}>
          Instructions: This form shall be completed by the DIRECT Employer of the OFW. Please fill out each field when applicable, otherwise write NA.
        </Text>

        {/* Personal Information Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Personal Information</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Name:</Text>
              <Text style={styles.value}>{data.name || 'N/A'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>NRIC:</Text>
              <Text style={styles.value}>{data.nric || 'N/A'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Residence Address:</Text>
              <Text style={styles.value}>{data.residence || 'N/A'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Zip Code:</Text>
              <Text style={styles.value}>{data.zip || 'N/A'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Mobile:</Text>
              <Text style={styles.value}>{data.mobile || 'N/A'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Email:</Text>
              <Text style={styles.value}>{data.email || 'N/A'}</Text>
            </View>
          </View>
          <Text style={styles.label}>Nationality:</Text>
          <Text style={styles.value}>{data.nationality || 'N/A'}</Text>
        </View>

        {/* Employment Information Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Employment Information</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Occupation:</Text>
              <Text style={styles.value}>{data.occupation || 'N/A'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Company:</Text>
              <Text style={styles.value}>{data.company || 'N/A'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Company Address:</Text>
              <Text style={styles.value}>{data.companyAddress || 'N/A'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Contact:</Text>
              <Text style={styles.value}>{data.contact || 'N/A'}</Text>
            </View>
          </View>
        </View>

        {/* Family Information Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Family Information</Text>
          <Text style={styles.label}>Monthly Family Income:</Text>
          <Text style={styles.value}>${data.income || 'N/A'}</Text>
          
          <Text style={styles.label}>Number of Members in the Household by Age Group:</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>0-20 years old:</Text>
              <Text style={styles.value}>{data.ageGroup1 || '0'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>21-65 years old:</Text>
              <Text style={styles.value}>{data.ageGroup2 || '0'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>65 years old and above:</Text>
              <Text style={styles.value}>{data.ageGroup3 || '0'}</Text>
            </View>
          </View>
          
          <Text style={styles.label}>Total Number of Staff in the Company:</Text>
          <Text style={styles.value}>{data.staff || ''}</Text>
        </View>

        {/* Signature and Consent Section - Side by Side */}
        <View style={styles.row}>
          {/* Employer Signature */}
          <View style={[styles.section, styles.column]}>
            <Text style={styles.sectionTitle}>Employer Signature</Text>
            <Text style={styles.label}>Employer Name and Signature:</Text>
            <Text style={styles.value}>{data.signature || ''}</Text>
            <Text style={styles.label}>Date:</Text>
            <Text style={styles.value}>{data.date || ''}</Text>
          </View>

          {/* Consent Section */}
          <View style={[styles.section, styles.column]}>
            <Text style={styles.sectionTitle}>Consent for Data Processing</Text>
            <Text style={styles.value}>
              I hereby consent to the collection and processing of my personal data by the Department of Migrant Workers for the purpose of evaluating my application and other related services.
            </Text>
            <Text style={styles.value}>
              I understand that my personal data will be handled in accordance with the Data Privacy Act of 2012 and other applicable laws.
            </Text>
            
            <Text style={styles.label}>Name and Signature:</Text>
            <Text style={styles.value}>{data.consentName || ''}</Text>
            <Text style={styles.label}>Date:</Text>
            <Text style={styles.value}>{data.consentDate || ''}</Text>
          </View>
        </View>

        <Text style={styles.footer}>
          Generated on {new Date().toLocaleDateString()} | Booking ID: {data.booking_id || ''}
        </Text>
      </Page>
    </Document>
  );
};

export default ExportDeclarationIncomeForm;